export const desktopSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.default",
  minWidth: 640,
  minHeight: "fit-content",
  maxHeight: "90%",
  overflow: "auto",
  outline: "none",
  borderRadius: 2,
  padding: 4,
};

export const mobileSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.default",
  height: "fit-content",
  width: "80%",
  borderRadius: 2,
  overflow: "scroll",
  p: 4,
};
